<template>
       <div class="side" id="side" v-on:change="getData(this.pk)" >      
        <b-card-group deck >          
          <b-card  header-tag="header" footer-tag="footer" v-bind:img-src="poidata.picture" img-height=250  overlay>
            <template v-slot:header>
              <b-card-title>{{poidata.nume}}</b-card-title>

            </template>
            
            <b-card-text>
                   <b-icon-x-circle-fill  class="rounded-circle bg-light" font-scale="2"  align=right @click="$emit('closehide')"></b-icon-x-circle-fill>
            </b-card-text>

                      
            <template v-slot:footer>
              <b-list-group >
                <b-list-group-item align=center>
                    <div class="sidebar-icons">                      
                      <b-img class="sidebar-circle" title="Accesibil" v-if="poidata.tipaccesibil_nume === 'Accesibil'" src="./img/accesibil.svg" > </b-img>
                      <b-img class="sidebar-circle" title="Moderat Accesibil" v-else-if="poidata.tipaccesibil_nume === 'Moderat Accesibil'" src="./img/moderataccesibil.svg" > </b-img>
                      <b-img class="sidebar-circle" title="Inaccesibil" v-else src="./img/inaccesibil.svg" > </b-img>
                      <b-img class="sidebar-circle" v-bind:src="CattrimText()" height="45px" > </b-img>
                    </div>  
                    <div class="sidebar-buttons">
                      <b-link title="Website" v-bind:href="poidata.website">
                        <b-img class="sidebar-circle"  src="./img/misc/questionmark.svg" > </b-img>
                      </b-link>                       
                      
                      <b-link title="Website" v-bind:href="poidata.website">
                        <b-img class="sidebar-circle"  src="./img/misc/website.svg" > </b-img>
                      </b-link>                      
                      <b-link title="Navigheaza" v-bind:href="getmapUrl()">
                        <b-img class="sidebar-circle" src="./img/misc/directions.svg" > </b-img>
                      </b-link>
                    
                    </div>
                </b-list-group-item>
                <b-list-group-item>{{poidata.descriere}}</b-list-group-item>
                <b-list-group-item>Locul este: <strong class="custom-sidebar-info-text-middle">{{poidata.tipaccesibil_nume}}</strong></b-list-group-item>
                <b-list-group-item>Categorie: <strong class="custom-sidebar-info-text-middle">{{poidata.categorie_nume}}</strong></b-list-group-item>
                <b-list-group-item>Subcategorie: <strong class="custom-sidebar-info-text-middle">{{poidata.subcategorie_nume}}</strong> </b-list-group-item>
                <b-list-group-item class="custom-mentiuni">Mentiuni: {{poidata.date_accesibilitate}}</b-list-group-item>
              </b-list-group>
            </template>
          </b-card>
          
        </b-card-group>
  
    </div>
    
</template>

<script>
import axios from 'axios'
export default {
    name: 'SideBar',    
    props: {
        pk: {type: Number},
        apiresourceurl: {type: String}
    },
    watch: {
       pk: function(newVal, oldVal) { // watch it
        axios 
          .get(`${this.apiresourceurl}/poi-el/${newVal}/`)
          .then(response => (this.poidata = response.data))
          console.log('Prop changed: ', newVal, ' | was: ', oldVal)
       }           
    },
    data: () => {
      return ({
        isAccesibil:true,
        categorys: 'None',
        poidata: []
      })
    },
    methods: {
      getmapUrl() {
        return `http://maps.google.com/maps?q=${this.poidata.lat},${this.poidata.lng}`;        
      },
      CattrimText() {
        if (this.poidata.categorie_nume) {
          return `./img/categories/${this.poidata.categorie_nume.toLowerCase().trim()}.svg`
        }
        else {
          return `./img/categories/${this.categorys.toLowerCase().trim()}.svg`
        }
      }
    },
    computed: {
      headerText() {
        return this.poidata.nume;
      }
    },
    mounted() {
      axios 
          .get(`${this.apiresourceurl}/poi-el/1418/`)
          .then(response => (this.poidata = response.data))
        return this.poidata.nume;
      }    
}
</script>

<style scoped>
div.side {
  max-width:  500px;
  height: 100%;
	z-index: 6;
  display: block;
	position: absolute;
    float: left;
    /* box-shadow: 0 0 12px 0 rgba(0,0,0,.1), 0 10px 30px 0 rgba(0,0,0,.2); */
	}
.bi-x-circle-fill {
    float: right;    
  }
.title-card-text {
  height: 250px;
}
.card-title {
  float: left;
}
.card-img {
  width: 100%;
  max-width: 500px;
  min-height: 250px;
}
.card-footer {
  padding: 0 0;
}
.list-group {
  max-width: 500px;
}
.list-group-item {
  padding: 0.25rem 0.35rem;
}

.sidebar-circle {
  height: 48px;
  width: 48px;
  padding: 4px;  
}
.sidebar-circle:hover {
  opacity: 0.5;
}

.sidebar-icons{
    float: left;
}

.sidebar-buttons {
  float: right;
}
.btn-sidebar {
  background-color: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.125);
}
.custom-mentiuni {
  height: 200px;
}
.custom-sidebar-info-text-middle{
  margin-inline: 10px;
}

</style>